module.exports = __webpack_public_path__ + "img/icons-16-edit.31ec3a78.svg";